import { Stack, Typography } from "@mui/material";
import { tokens } from "../../store/tokens";

// One row of a price breakdown card: a label (+ optional description/icon)
// on the left, a computed value on the right. `highlight` gives the final
// "you'll receive" row a teal tint so it reads as the headline number.
const PriceSummaryRow = ({
  label,
  description,
  value,
  icon,
  highlight = false,
  isLast = false,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{
      width: "100%",
      padding: "16px",
      borderBottom: isLast ? "none" : `1px solid ${tokens.color.line}`,
      bgcolor: highlight ? tokens.color.tealLight : "transparent",
    }}
  >
    <Stack sx={{ maxWidth: "65%" }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        {icon}
        <Typography
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.95rem",
            fontWeight: 600,
            color: tokens.color.ink,
          }}
        >
          {label}
        </Typography>
      </Stack>
      {description && (
        <Typography
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.8rem",
            color: tokens.color.inkMuted,
            mt: 0.25,
          }}
        >
          {description}
        </Typography>
      )}
    </Stack>

    <Typography
      sx={{
        fontFamily: tokens.font.body,
        fontSize: "1rem",
        fontWeight: highlight ? 700 : 600,
        color: highlight ? tokens.color.tealDark : tokens.color.ink,
        whiteSpace: "nowrap",
      }}
    >
      {value}
    </Typography>
  </Stack>
);

export default PriceSummaryRow;
